module.exports = __webpack_public_path__ + "static/media/blueCheckIcon.b19a9d64.svg";